"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RateType;
(function (RateType) {
    RateType["Owner"] = "Owner";
    RateType["Captain"] = "Captain";
    RateType["Crew"] = "Crew";
    RateType["Custom"] = "Custom";
    RateType["CustomTimeBased"] = "Custom (Time Based)";
    RateType["FuelIncluded"] = "Fuel Included";
    RateType["Gratuity"] = "Gratuity";
    RateType["BookingFee"] = "Booking Fee";
    RateType["Cleaning"] = "Cleaning";
})(RateType = exports.RateType || (exports.RateType = {}));
